<template>
    <div class="card">
        <slot></slot>
    </div>
</template>

<script>
export default {
    // props: {
    //     style: {
    //         type: Object,
    //         require: false,
    //         default() {
    //             return {}
    //         }
    //     }
    // }
}
</script>

<style scoped>
.card {
    background: #FFFFFF;
    box-shadow: 0px 10px 20px #E6E8F0;
    border-radius: 12px;
    overflow: hidden;
    padding: 30px;
    box-sizing: border-box;
}
</style>